import React from "react";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";

interface BusinessTypeSelectProps {
  value: string;
  onChange: (value: string) => void;
}

const businessTypes = [
  { label: "Laundry", value: "Laundry" },
  { label: "Restaurant", value: "Restaurant" },
  { label: "Carwash", value: "Carwash" },
  { label: "Vehicle retailer", value: "Vehicle retailer" },
  { label: "Salon", value: "Saloon" },
  { label: "Grocery", value: "Grocery" },
];

export const BusinessTypeSelect: React.FC<BusinessTypeSelectProps> = ({
  value,
  onChange,
}) => {
  return (
    <div className="mb-4">
      <label className="text-sm font-medium text-gray-600 mb-1 block">
        Business type <span className="text-red-500">*</span>
      </label>

      <div className="flex items-center border rounded-lg px-3 py-2 bg-gray-50 focus-within:ring-2 focus-within:ring-blue-500">
        <span className="mr-2 text-gray-400">
          <AddBusinessIcon fontSize="small" />
        </span>

        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full bg-transparent outline-none text-gray-700"
        >
          <option value="" disabled >Select business type</option>

          {businessTypes.map((type) => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};